<template>
  <div class="lms-wrapper-two">
    <student-nav @route-changed="toggleNavbar(false)"></student-nav>
    <!-- <div class="lms-sidebar">
      <div class="lms-sidebar-body">
        <vue-custom-scrollbar :style="`height: ${scrollHeight.nav}px`">
          <div :class="`card ${$store.state.app.isMobile ? 'bd-0' : ''}`">
            <div class="card-body">
              
            </div>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div> -->
    <div class="lms-content">
      <student-header ref="stdnthdr" filterTypeHolder="Бүх төрөл ..." filterName="Ном хайх ..." @loctype-slcd="filterParams.type=$event"
        class="filled" @toggle-navbar="toggleNavbar($event)" @on-filter="doFilter(5, $event)"
        @loctype-cleared="loctypeCleared" />

      <div class="lms-content-body container" style="bottom: 0; height: calc(100vh - 80px)">
        <div class="bg-white rounded-20 mg-30 pd-30" >
          <ul class="nav nav-line nav-line-profile mg-b-10 wd-100p">
            <li class="nav-item" v-for="(type, i) in types" :key="'tt' + i">
              <router-link
                :to="{ name: $route.name, params: { cid: type.id } }"
                :class="
                  `nav-link d-flex align-items-center ${
                    $route.params.cid == type.id ? 'active' : ''
                  }`
                "
                >{{ type.s1 }}</router-link
              >
            </li>
            <li class="nav-item" style="margin-left: auto">
              <a
                @click="editShow(0)"
                class="btn btn-xs btn-uppercase btn-success align-items-right"
              >
                <feather type="plus"></feather>Шинэ хүсэлт илгээх
              </a>
            </li>
          </ul>

          <div class="row">
            <div class="col-lg-8 col-xl-9">
              <vue-custom-scrollbar class=""
                :style="`height: ${scrollHeight.content}px; position: relative; `"
              >
                <template v-if="canView">
                  <div class="row row-sm mg-b-25">
                    <template v-if="tasks.length > 0">
                      <ul class="list-group list-group-flush tx-13 wd-100p">
                        <li
                          v-for="(task, i) in tasks"
                          :key="'tsk_' + i"
                          class="list-group-item d-flex pd-sm-x-20"
                          role="button"
                          @click="showTaskDetail(task.id)"
                        >
                          <div class="avatar" style="min-width: 40px">
                            <span
                              :class="
                                `avatar-initial rounded-circle bg-${
                                  colors[
                                    (task.id + '')[(task.id + '').length - 1]
                                  ]
                                }`
                              "
                              >{{ task.task[0] }}</span
                            >
                          </div>
                          <div class="pd-l-10">
                            <p class="tx-medium mg-b-0">{{ task.task }}</p>
                            <small class="tx-12 tx-color-03 mg-b-0">{{
                              task.dueStartDate | moment("YYYY.MM.DD")
                            }}</small>
                          </div>
                          <div
                            class="mg-l-auto text-right"
                            v-if="task.isCompleted"
                          >
                            <p class="tx-medium mg-b-2">
                              {{ task.completedAt | moment("YYYY.MM.DD") }}
                            </p>
                            <small class="tx-12 badge badge-success mg-b-0"
                              >шийдвэрлэгдсэн</small
                            >
                          </div>
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <div class="wd-100p">
                        <ul class="list-group list-group-flush tx-13">
                          <li class="list-group-item d-flex pd-sm-x-20">
                            <div
                              class="container d-flex justify-content-center ht-100p"
                            >
                              <div
                                class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
                              >
                                <div class="wd-80p wd-sm-300 mg-b-15">
                                  <img
                                    src="assets/svg/boxempty.svg"
                                    alt
                                    class="img-fluid"
                                  />
                                </div>
                                <h4 class="tx-18 text-muted">
                                  Мэдээлэл хоосон байна.
                                </h4>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </template>
                  </div>
                </template>
                <template v-else>
                  <div class="align-center">
                    <div class="vertical-middle">
                      <div class="alert alert-warning mg-b-0" role="alert">
                        <h6 class="alert-heading">Хандах эрх хүрэхгүй байна!</h6>
                        <hr />
                        <p class="mb-0">Гишүүн болсноор үзэх боломжтой</p>
                      </div>
                    </div>
                  </div>
                </template>
              </vue-custom-scrollbar>
            </div>
            <div class="col-sm-7 col-md-5 col-lg-4 col-xl-3 mg-t-40 mg-lg-t-0">
              <vue-custom-scrollbar
                :style="`height: ${scrollHeight.right}px; position: relative;`"
              >
                <h6 class="tx-uppercase tx-semibold mg-b-15">Ангилал</h6>
                <nav class="nav nav-classic tx-13">
                  <router-link
                    :to="{ name: $route.name, params: { cid: type.id } }"
                    :class="
                      `nav-link ${$route.params.cid == type.id ? 'active' : ''}`
                    "
                    v-for="(type, i) in types"
                    :key="'st' + i"
                  >
                    <span>{{ type.s1 }}</span>
                  </router-link>
                </nav>

                <!-- <go-points class="mg-t-20" /> -->
              </vue-custom-scrollbar>
            </div>
          </div>
        </div>
      </div>
    </div>
    <task-dialog
      v-if="tskDetail.id > 0"
      :id.sync="tskDetail.id"
      @on-task-close="tskDetail.id = 0"
      :detailSettingProp="{
        hideMainMenu: true,
        hideRightSidebar: false,
        boxSetting: { hideToolbar: true, listSetting: { disableDetail: true } }
      }"
    ></task-dialog>
    <!-- @on-attach="showFile($event)"
      @on-task-posted="taskPosted"
    -->
    <task-edit
      :prms.sync="taskEdit"
      :show.sync="taskEdit.show"
      :disablePreEditCheck="true"
      @on-task-posted="taskPosted"
      @on-edit-close="editClosed"
    ></task-edit>
    <b-modal
      v-model="modal.show"
      hide-footer
      :title="modal.data.task"
      centered
      body-class="pd-0"
      size="xl"
      scrollable
    >
      <div class="modal-body pd-0">
        <!-- <file-preview
          :id="modal.data.defaultAttachmentId"
          v-if="modal.rdy"
          :force="true"
          :minusHeight="200"
        />-->
      </div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import { request } from "@/api/all";

export default {
  components: {
    vueCustomScrollbar,
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    // filePreview: () => ({
    //   component: import("@/components/modules/media/previewPage.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    taskDialog: () => ({
      component: import("@/components/task/detail/dialog.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    taskEdit: () => ({
      component: import("@/components/task/edit/base"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
    // goPoints: () => ({
    //   component: import("@/views/modules/lms/components/points"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
  },
  data() {
    return {
      tmzPointSuccess: 0,
      point: {},
      scrollHeight: {
        contentToolbarHeight: 49,
        nav: 0,
        content: 0,
        right: 0
      },
      nowDate: null,
      types: [],
      tasks: [],
      allCount: 0,
      typeKey: "lmsFeedbackType",
      ot: 514,
      groupLogo: "",
      modal: {
        id: 0,
        rdy: false,
        show: false,
        data: {}
      },
      canView: true,
      tmzPointSuccess: 0,
      colors: [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "info",
        "indigo",
        "purple",
        "pink",
        "teal",
        "orange"
      ],
      tskDetail: {
        id: 0
      },
      taskEdit: {
        id: 0,
        show: false,
        render: false,
        objectTypeId: 514,
        projectId: 0
      },
      project: {},
      filterParams:{
        task: '',
        type: 0
      }
    };
  },
  mounted() {
    this.toggleBodyClass("addClass", "app-lms");
    require("@/assets/css/dynamic.lms.css");

    window.addEventListener("resize", this.getWindowHeight);
    this.getWindowHeight();
    let _companyLogo = this.$store.state.app.groupSettings.filter(
      x => x.key == "companyLogo"
    );
    if (_companyLogo.length > 0 && _companyLogo[0].value != undefined) {
      this.groupLogo = _companyLogo[0].value;
    }

    let _pointSuccess = this.$store.state.app.groupSettings.filter(
      x => x.key == "tmzPointSuccess"
    );
    if (_pointSuccess.length > 0 && _pointSuccess[0].value != undefined) {
      this.tmzPointSuccess = parseInt(_pointSuccess[0].value, 10);
    }

    let prjs = this.$store.state.app.groupDefaultProjects.filter(
      x => x.objectTypeId == this.ot
    );

    //console.log(prjs)

    if (prjs != undefined && prjs.length) {
      this.project = prjs[0];
      //this.taskEdit.projectId = prjs[0].id;
    }

    // request({
    //   api: { method: "get", url: "learn/GetMyTMZPoint" },
    //   store: this.$store
    // }).then(res => {
    //   this.point = res.data;
    //   if (
    //     this.$store.state.user.userInfo.locType4Code == "member"
    //   ) {
    //     this.canView = true;
    //     this.init();
    //   }
    // });

    this.init();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  destroyed() {
    window.removeEventListener("resize", this.getWindowHeight);
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    loctypeCleared(){
      this.filterParams.type= null;
      this.$refs.stdnthdr.searchHandler();
      //this.filterKey++;
      //console.log('etssiin log');
    },
    init() {
      request({
        api: { method: "get", url: "type/getdata" },
        params: {
          key: this.typeKey,
          getParentType: false
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.types = res.data.types;
        }
      });

      request({
        api: { method: "POST", url: "TaskCore/GetCoreList" },
        data: {
          skip: 0,
          size: 100,
          ot: this.ot,
          model: {
            //isPublic: true,
            isTender: false,
            locTypeId:
              this.$route.params.cid > 0 ? this.$route.params.cid : null
          }
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log('GetCoreList', res);
          this.allCount = res.data.allCount;
          this.nowDate = res.data.nowDate;
          this.tasks = res.data.tasks;
        }
      });

      //   if (this.$route.params.id == 0) {
      //     request({
      //       api: { method: "POST", url: "TaskCore/GetCoreList" },
      //       data: {
      //         skip: 0,
      //         size: 200,
      //         ot: this.ot,
      //         model: {
      //           isTender: false
      //         }
      //       },
      //       store: this.$store
      //     }).then(res => {
      //       if (res != false) {
      //         this.allCount = res.data.allCount;
      //         this.nowDate = res.data.nowDate;
      //         this.tasks = res.data.tasks;
      //       }
      //     });
      //   } else {
      //     this.tskDetail.id = this.$route.params.id;
      //   }
    },
    editShow(id) {
      this.taskEdit.id = id;
      this.taskEdit.objectTypeId = this.ot;
      this.taskEdit.projectId = this.project.id;
      this.taskEdit.render = true;
      this.$nextTick(function() {
        this.taskEdit.show = true;
      });
    },
    editClosed() {
      this.taskEdit.render = false;
      this.taskEdit.show = false;
      this.taskEdit.id = 0;
    },
    taskPosted(e) {
      this.editClosed();
      this.init();
      this.showTaskDetail(e.obj.id);
    },
    showTaskDetail(id) {
      this.tskDetail.id = id;
    },
    taskDetail() {},
    showAttach() {},
    onLoaded() {},
    taskClosed() {
      //console.log("taskClosed fired");
    },
    taskDetail(id) {
      this.toggleBodyClass("addClass", "dynamic-locker");

      request({
        api: { method: "get", url: "task/taskInheritedDetail" },
        params: { id: id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.modal.id = id;
          this.modal.data = res.data.task;
          this.modal.show = true;
          this.modal.rdy = true;
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleNavbar(shown) {
      if (this.navbarMode == 0) {
        this.navbarMode = 1;
        this.toggleBodyClass("addClass", "lms-sidebar-show");
      } else if (this.navbarMode == 1) {
        if (shown) {
          this.toggleBodyClass("addClass", "navbar-nav-show");
        } else {
          this.navbarMode = 0;
          this.toggleBodyClass("removeClass", "lms-sidebar-show");
        }
      }
    },
    getWindowHeight() {
      let contentSub = 210;
      let navSub = 120;
      let rightSub = 210;
      if (screen.width <= 1024) {
        contentSub = 85;
        navSub = 85;
        rightSub = 85;
      }

      contentSub += this.scrollHeight.contentToolbarHeight;
      rightSub += this.scrollHeight.contentToolbarHeight;

      this.scrollHeight.content = window.innerHeight - contentSub;
      this.scrollHeight.nav = window.innerHeight - navSub;
      this.scrollHeight.right = window.innerHeight - rightSub;
    }
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      //console.log("wathc detected")
      if (newRoute.params.cid != oldRoute.params.cid) {
        this.$nextTick(() => {
          this.init();
        });
      }
    }
  }
};
</script>
